export const MEGACABLE_ACCESS_TOKEN_KEY = 'megacable_access_token';
export const MEGACABLE_TOKEN_TYPE_KEY = 'megacable_token_type';
export const MEGACABLE_CREDIT_ENABLE_KEY = 'megacable_credit_enable';
export const MEGACABLE_EXPIRES_AT_KEY = 'megacable_expires_at';
export const MEGACABLE_PROFILE_KEY = 'megacable_profile';
export const MEGACABLE_INSTALLATION_DATE_KEY = 'megacable_installation_date';

/** Header usado por `/Megacable/credito` y demás rutas Megacable autenticadas. */
export const MEGACABLE_AUTH_HEADER = 'X-Megacable-Authorization';

/** Header Swagger `megacable-token`: JWT sin prefijo Bearer. */
export const MEGACABLE_SWAGGER_TOKEN_HEADER = 'megacable-token';

/** Rutas Megacable que no deben llevar token del interceptor. */
export const MEGACABLE_AUTH_EXCLUDED_PATHS = [
  '/Megacable/login',
  '/Megacable/plans',
  '/Megacable/logout'
] as const;
